import { Injectable } from '@angular/core';
import { KeepAwake } from '@capacitor-community/keep-awake';
@Injectable({
  providedIn: 'root',
})
export class KeepAwakeService {

  constructor() {
  }

  async enable() {
    console.debug('KeepAwakeService.enable');
    await KeepAwake.keepAwake();
  }

  async disable() {
    console.debug('KeepAwakeService.disable');
    await KeepAwake.allowSleep();
  }
}
